import { useMutation } from 'react-query';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { ROUTES } from 'constants/routes';
import { ErrorResponse } from 'types/network';
import { PatientInsuranceInfo } from 'types/patientInsurance';
import { useMswManager } from 'lib/util/useMswManager';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';

export const usePartnerGetPatientInsurance = () => {
  const Axios = useAuthenticatedAxios();

  useMswManager(
    HrznGatewayMswBuilder.create().post(ROUTES.PartnerGetPatientInsurance, {
      data: {
        empID: 0,
        id: 'P4838',
        reqAction: 0,
        systemName: null,
        patientInformation: {
          guarantorFirstName: 'GFIRSTNAME',
          guarantorLastName: 'GLASTNAME',
          patientFirstName: 'FIRSTNAME',
          patientLastName: 'LASTNAME',
          patientAddress: '1234 SOMESTREET LN',
          patientCity: 'SOMECITY',
          patientState: 'FL',
          patientZip: '32068',
          patientHomePhone: '1234567890',
          patientCellPhone: null,
          patientEmail: '',
          patientSex: 'M',
          patientDOB: '1975-11-21T00:00:00',
          patientMarriedStatus: 'Unknown',
          patientEmployedStatus: 'Unemployed',
          patientInjuryTypeDesc: null,
          patientInjuryState: null,
          claimNumber: 0,
          employerName: null,
          employerAddress: null,
          employerCity: null,
          employerState: null,
          employerZipCode: null
        },
        primaryInsurance: {
          id: '2609727',
          planName: 'BC/BS OF FL PPO',
          groupID: '300126',
          policyID: 'VXJ123456789',
          companyAddress: 'PO BOX 1234',
          companyCity: 'JACKSONVILLE',
          companyState: 'FL',
          companyZip: '32231',
          insuredRelationshipToPatient: '1',
          insuredFirstName: 'IFIRSTNAME',
          insuredLastName: 'ILASTNAME',
          insuredSex: 'M',
          insuredAddress: '1234 SOMESTREET LN',
          insuredCity: 'SOMECITY',
          insuredState: 'FL',
          insuredZip: '32068',
          employerName: null,
          insuredDOB: '1975-11-21T00:00:00'
        },
        secondaryInsurance: {
          id: '123578',
          planName: 'SELF PAY',
          groupID: '',
          policyID: '',
          companyAddress: '',
          companyCity: '',
          companyState: '',
          companyZip: '',
          insuredRelationshipToPatient: '1',
          insuredFirstName: '',
          insuredLastName: '',
          insuredSex: 'U',
          insuredAddress: '',
          insuredCity: '',
          insuredState: '',
          insuredZip: '',
          employerName: null,
          insuredDOB: null
        },
        tertiaryInsurance: {
          id: '1234566789',
          planName: 'SELF PAY',
          groupID: '',
          policyID: '',
          companyAddress: '',
          companyCity: '',
          companyState: '',
          companyZip: '',
          insuredRelationshipToPatient: '1',
          insuredFirstName: '',
          insuredLastName: '',
          insuredSex: 'U',
          insuredAddress: '',
          insuredCity: '',
          insuredState: '',
          insuredZip: '',
          employerName: null,
          insuredDOB: null
        }
      }
    })
  );

  return useMutation<
    PatientInsuranceInfo,
    ErrorResponse,
    { account: number; srcSystemKey: number }
  >(async ({ account, srcSystemKey }) => {
    const { data } = await Axios({
      method: 'post',
      url: `/?route=${ROUTES.PartnerGetPatientInsurance}`,
      data: {
        account,
        srcSystemKey
      }
    });
    return data;
  });
};
